import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import { FONT_FAMILY_SERIF } from "../../theme";
import { useTestimonials } from "../../hooks/useTestimonials";

export const Testimonials: React.FC = () => {
  const { data: testimonials, isLoading, error } = useTestimonials();

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    console.error("Error loading testimonials:", error);
    return null;
  }

  if (!testimonials || testimonials.length === 0) {
    console.log("No testimonials found");
    return null;
  }

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
        gap: 4,
      }}
    >
      {testimonials.map((testimonial) => (
        <Box key={testimonial.id}>
          <Box
            sx={{
              textAlign: "center",
              px: { xs: 2, md: 3 },
              py: 4,
            }}
          >
            {/* Quote Icon */}
            <FormatQuoteIcon
              sx={{
                fontSize: "3rem",
                color: "rgba(0, 0, 0, 0.1)",
                mb: 2,
              }}
            />

            {/* Quote */}
            <Typography
              sx={{
                fontFamily: FONT_FAMILY_SERIF,
                fontSize: "1.0625rem",
                fontStyle: "italic",
                lineHeight: 1.8,
                color: "text.secondary",
                mb: 3,
              }}
            >
              "{testimonial.content}"
            </Typography>

            {/* Author */}
            <Typography
              variant="subtitle2"
              sx={{
                fontFamily: '"Playfair Display", serif',
                fontWeight: 600,
                color: "text.primary",
                mb: 0.5,
              }}
            >
              {testimonial.client_name}
            </Typography>

            {/* Role */}
            {testimonial.client_title && (
              <Typography
                variant="caption"
                sx={{
                  fontFamily: '"Playfair Display", serif',
                  color: "text.secondary",
                  fontSize: "0.875rem",
                }}
              >
                {testimonial.client_title}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
